import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useUpdateAPI, useCreateAPI } from '../../api/contractors/use-api';

export const useUpdateContractor = () => {
  const dispatch = useDispatch();
  const { mutate, isLoading, data, isSuccess } = useUpdateAPI();

  useEffect(() => {
    if (data && isSuccess) {
    }
  }, [dispatch, data, isSuccess]);

  const onUpdateContractor = useCallback((data) => mutate(data), [mutate]);

  return onUpdateContractor;
};

export const useCreateContractor = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { mutate, isLoading, data, isSuccess } = useCreateAPI();

  useEffect(() => {
    if (data && isSuccess) {
      history.push('/contractor-editor/' + data.data.id);
    }
  }, [dispatch, data, isSuccess]);

  const onCreateContactor = useCallback((data) => mutate(data), [mutate]);

  return onCreateContactor;
};
